import { getRequest } from './http'
import config from '../config'

export type DataSubmission = {
  Data_Submission_Id: string
  Period_From: string
  Period_To: string
}

type BeekeeperInfo = {
  AuthorisationNumber: string
  CompanyName: string
  FirstName: string
  LastName: string
  EmailAddress: string
  AnniversaryDate: string
  CompanyEmail: string
  Data_Submissions: DataSubmission[]
}

export async function getBeekeeperInfo() {
  const beekeeperInfo = await getRequest<BeekeeperInfo>({
    url: `${config.HOSTED_API_URL}/beekeeper-info`,
    addAuthHeaders: true,
  })

  return beekeeperInfo
}
